import React from "react";
import styled from "@emotion/styled";
import snowflakes from "assets/img/snowflakes.png";
import {motion, Variants} from "framer-motion";
import {observer} from "mobx-react";

const Wrapper = styled(motion.div)`
	background: url("${snowflakes}") center;
	background-size: 100px 100px;
	position: absolute;
	width: 100%;
	height: 100%;
`;

interface IProps {
	animate?: boolean;
	infinity?: boolean;
	className?: string;
}

export const SnowAnimation: React.FC<IProps> = observer(({animate, infinity, className}) => {
	const animationProps: Variants = {
		initial: {y: "-200%", transition: {duration: 0}},
		animate: {
			y: "100%",
			transition: {
				repeat: infinity ? Infinity : 0,
				duration: 3,
				repeatType: "loop",
			},
		},
		exit: {y: "-200%"},
	};

	return (
		<Wrapper
			className={className}
			initial={"initial"}
			variants={animationProps}
			animate={animate ? "animate" : "initial"}
		/>
	);
});
